import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/p25.css';

const API = process.env.REACT_APP_BACKEND_URL;

export default function Access25Page() {
  const [params] = useSearchParams();
  const t = params.get('t');
  const [phase, setPhase] = useState('checking');
  const [info, setInfo] = useState({});
  const [email, setEmail] = useState('');
  const [sentMsg, setSentMsg] = useState('');

  useEffect(() => {
    axios.get(`${API}/api/access25/session${t ? `?t=${t}` : ''}`, { withCredentials: true })
      .then(({ data }) => { setInfo(data); setPhase('product'); })
      .catch(() => setPhase('lost'));
  }, [t]);

  const resend = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(`${API}/api/access25/resend-link`, { email });
      setSentMsg(data.message);
    } catch { setSentMsg('If that email has a purchase, a link is on its way.'); }
  };

  if (phase === 'checking') return <div className="p25-shell"><div className="p25-card"><div className="p25-spinner" /></div></div>;

  if (phase === 'lost') return (
    <div className="p25-shell" data-testid="access25-lost">
      <div className="p25-card">
        <h1>Lost your link?</h1>
        <p className="p25-sub">Enter the email you bought with and we'll resend your personal access link.</p>
        {sentMsg ? <p className="p25-sent" data-testid="resend-confirmation">{sentMsg}</p> : (
          <form onSubmit={resend}>
            <input className="p25-input" type="email" required placeholder="you@email.com"
              value={email} onChange={e => setEmail(e.target.value)} data-testid="resend-email-input" />
            <button className="p25-btn" type="submit" data-testid="resend-submit">Send my link</button>
          </form>
        )}
        <p className="p25-fine">Haven't bought yet? <Link to="/25-for-25">See 25 for 25</Link></p>
      </div>
    </div>
  );

  return (
    <div className="p25-product" data-testid="access25-product">
      {!info.onboarding_complete && (
        <div className="p25-banner" data-testid="finish-profile-banner">
          <span>Finish setting up your profile.</span>
          <Link to={`/workouts/25-for-25/welcome?t=${info.token}`}>Finish</Link>
          <button onClick={e => e.currentTarget.parentElement.remove()} aria-label="Dismiss">×</button>
        </div>
      )}
      <iframe
        src={`${API}/api/access25/app${t ? `?t=${t}` : ''}`}
        title="25 for 25 workout library"
        className="p25-frame"
        data-testid="app25-frame"
      />
    </div>
  );
}
